<script setup>
import { onMounted } from "vue";
import cormorantFont from "~/assets/fonts/Cormorant.woff2";

const nuxtApp = useNuxtApp();
const loading = ref(false);
nuxtApp.hook("page:loading:start", () => {
  loading.value = true;
});
nuxtApp.hook("page:loading:end", () => {
  loading.value = false;
});

const { locale } = useI18n();
const route = useRoute();

const isHomePage = computed(() => {
  const path = route.path;
  return path === '/' || path === '/en' || path === '/tr';
});

const baseUrl = 'https://salamisbayconti.com';

const hreflangLinks = computed(() => {
  const path = route.path;
  // Strip /en prefix to get the base path
  const basePath = path.startsWith('/en') ? path.slice(3) || '/' : path;
  const trUrl = basePath === '/' ? baseUrl : `${baseUrl}${basePath}`;
  const enUrl = basePath === '/' ? `${baseUrl}/en` : `${baseUrl}/en${basePath}`;

  return [
    { rel: 'alternate', hreflang: 'tr', href: trUrl, key: 'hreflang-tr' },
    { rel: 'alternate', hreflang: 'en', href: enUrl, key: 'hreflang-en' },
    { rel: 'alternate', hreflang: 'x-default', href: trUrl, key: 'hreflang-x-default' },
  ];
});

useHead({
  link: [
    {
      rel: "preload",
      href: cormorantFont,
      as: "font",
      type: "font/woff2",
      crossorigin: "anonymous",
    },
  ],
});

useHead({
  titleTemplate: (titleChunk) => {
    if (!titleChunk || titleChunk === 'Salamis Bay Conti Resort Hotel') {
      return locale.value === 'en'
        ? 'Salamis Bay Conti Resort Hotel | Cyprus 5-Star Ultra All-Inclusive Hotel'
        : 'Salamis Bay Conti Resort Hotel | Kıbrıs 5 Yıldızlı Ultra Her Şey Dahil Otel';
    }
    return `${titleChunk} | Salamis Bay Conti Resort Hotel`;
  },
  htmlAttrs: {
    lang: computed(() => locale.value === 'en' ? 'en' : 'tr')
  },
  link: hreflangLinks
});

// og:title / og:description / og:url are derived per page from its own
// title, description and canonical (plugins/og-from-page-meta.ts) — setting
// the homepage's copies here made every other page share them.
const ogLocale = computed(() => locale.value === 'en' ? 'en_US' : 'tr_TR');
const ogLocaleAlternate = computed(() => locale.value === 'en' ? 'tr_TR' : 'en_US');

useSeoMeta({
  ogLocale,
  ogLocaleAlternate,
});
</script>
<template>
  <div>
    <SiteHeader />
    <main class="main-body">
      <div class="css-script-ads"></div>
      <NuxtLayout>
        <SmartBanner v-if="isHomePage" />
        <NuxtPage />
      </NuxtLayout>
    </main>
  </div>
  <!-- Google tag (gtag.js) -->
</template>

<style lang="scss">
.main-body {
  overflow-x: hidden;
}
@keyframes pulse {
  0% {
    box-shadow:
      0 0 5px #c9a26c,
      0 0 10px #c9a26c,
      0 0 15px #c9a26c,
      0 0 20px #c9a26c;
  }
  50% {
    box-shadow:
      0 0 10px #c9a26c,
      0 0 20px #c9a26c,
      0 0 30px #c9a26c,
      0 0 40px #c9a26c;
  }
  100% {
    box-shadow:
      0 0 5px #c9a26c,
      0 0 10px #c9a26c,
      0 0 15px #c9a26c,
      0 0 20px #c9a26c;
  }
}
</style>
